<template>
    <FormControl
        label="Maximum booking days in advance (in days)"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_UpdateService_MaximumBookingDaysInAdvance,
            )
        "
    >
        <TextInput
            type="number"
            inputmode="numeric"
            step="1"
            :name="
                RequestBodyKeyEnum.App_UpdateService_MaximumBookingDaysInAdvance
            "
            :value="service?.maximumBookingDaysInAdvance ?? '30'"
        />
    </FormControl>

    <FormControl
        label="Minimum booking hours in advance (in hours)"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_UpdateService_MinimumBookingHoursInAdvance,
            )
        "
    >
        <TextInput
            type="number"
            inputmode="numeric"
            step="1"
            :name="
                RequestBodyKeyEnum.App_UpdateService_MinimumBookingHoursInAdvance
            "
            :value="service?.minimumBookingHoursInAdvance ?? '24'"
        />
    </FormControl>

    <FormControl
        label="Minimum cancelation hours in advance (in hours)"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_UpdateService_MinimumCancelationHoursInAdvance,
            )
        "
    >
        <TextInput
            type="number"
            inputmode="numeric"
            step="1"
            :name="
                RequestBodyKeyEnum.App_UpdateService_MinimumCancelationHoursInAdvance
            "
            :value="service?.minimumCancelationHoursInAdvance ?? '24'"
        />
    </FormControl>

    <FormControl
        label="Interval between meeting (in minutes)"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_UpdateService_IntervalBetweenMeetings,
            )
        "
    >
        <TextInput
            type="number"
            inputmode="numeric"
            min="0"
            step="1"
            :name="RequestBodyKeyEnum.App_UpdateService_IntervalBetweenMeetings"
            :value="service?.intervalBetweenMeetings ?? '0'"
        />
    </FormControl>
</template>

<script setup lang="ts">
    import Service from '@/App/Service/Entity/Service'
    import { type PropType } from 'vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        service: {
            type: Object as PropType<Service | null>,
            default: null,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })
</script>
